import { Component, computed, inject, input, linkedSignal } from '@angular/core';
import { cva } from 'class-variance-authority';

import { BlocÉtat } from '../../models/bloc-état';
import { ConvertBlocEtatToStringPipe } from '../../pipes/convert-bloc-etat-to-string.pipe';

export const listVariants = cva('text-grey-10 py-xs px-sm paragraph-medium-medium rounded-full text-center', {
  variants: {
    variant: {
      [BlocÉtat.A_FAIRE]: 'bg-feedback-warning-lightest',
      [BlocÉtat.EN_COURS]: 'bg-feedback-informative-lightest',
      [BlocÉtat.FAIT]: 'bg-feedback-positive-lightest',
    },
  },
});

@Component({
  selector: 'app-bloc-etat',
  template: `
    <div>
      <span [class]="_computedClass()">{{ etatStr() }}</span>
    </div>
  `,
  providers: [ConvertBlocEtatToStringPipe],
})
export class BlocEtatComponent {
  readonly #convertBlocEtatToStringPipe = inject(ConvertBlocEtatToStringPipe);

  readonly etat = input<BlocÉtat>();

  readonly etatStr = linkedSignal(() => this.#convertBlocEtatToStringPipe.transform(this.etat()));

  protected readonly _computedClass = computed(() => listVariants({ variant: this.etat() }));
}
